import { useMemo } from "react";

import { useMachines } from "./use-machines";

interface UseHasDownstreamMachineOptions {
	enabled?: boolean;
}

export const useHasDownstreamMachine = ({ enabled = true }: UseHasDownstreamMachineOptions = {}) => {
	const { machines } = useMachines({
		machineTypes: ["PL1", "LantechCaseSealer", "SealProX"],
		refetchInterval: false,
		enabled,
	});

	const hasDownstreamMachine = useMemo(() => {
		if (machines.length === 0) {
			return false;
		}
		return machines.some(
			(machine) =>
				machine.machineType === "PL1" ||
				machine.machineType === "LantechCaseSealer" ||
				machine.machineType === "SealProX",
		);
	}, [machines]);

	return hasDownstreamMachine;
};
